export function activePhysicalStation(context) {
  return context?.stations?.find((station) => Number(station.id) === Number(context.activeStationId)) ?? null
}

export function activeNaftaPosInstance(context) {
  return activePhysicalStation(context)?.naftaPosInstances?.find(
    (source) => Number(source.id) === Number(context.activeNaftaPosInstanceId),
  ) ?? null
}

export function sourceSelectionState(context) {
  const station = activePhysicalStation(context)
  const sources = station?.naftaPosInstances ?? []
  return {
    station,
    sources,
    activeSource: activeNaftaPosInstance(context),
    requiresSelection: Boolean(context?.requiresNaftaPosSourceSelection),
  }
}
